import React from 'react';
import Hero from '../components/Hero';

function Home() {
  return (
    <div className="bg-ivory min-h-screen text-charcoal">
      <Hero />
      {/* Features Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="h-16 w-16 mx-auto mb-4 bg-moss rounded-full flex items-center justify-center">
              <svg className="h-8 w-8 text-ivory" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Trusted Breeders</h3>
            <p className="text-base text-charcoal/80">
              Connect with verified breeders offering high-quality reptiles and snakes
            </p>
          </div>
          <div className="text-center">
            <div className="h-16 w-16 mx-auto mb-4 bg-moss rounded-full flex items-center justify-center">
              <svg className="h-8 w-8 text-ivory" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Curated Listings</h3>
            <p className="text-base text-charcoal/80">
              Explore a wide variety of species with detailed descriptions and photos.
            </p>
          </div>
          <div className="text-center">
            <div className="h-16 w-16 mx-auto mb-4 bg-moss rounded-full flex items-center justify-center">
              <svg className="h-8 w-8 text-ivory" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Secure Transactions</h3>
            <p className="text-base text-charcoal/80">
              Buy and sell with confidence using our secure platform.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;